import { updateFormularioSecretariaMunicipalAgriculturaByUUID } from 'api/forms/pacote_formularios.api';
import { create } from 'zustand';

export interface QuadroServidoresSecretaria {
  nome: string,
  tipo_vinculo: string,
  telefone: string,
  grau_escolaridade: string,
  email: string,
  medio_tecnico_concluido: string,
  superior_concluido: string
}

export interface ServicosPrestadosDescritivo {
  id: number;
  secretaria_municipal_agricultura_uuid: string;
  servicos_prestados_orgao_agricultura_uuid: string;
  servicos_prestados_orgao_agricultura: {
    uuid: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    nome_servico: string;
  };
}

export interface ProgramaAssistenciaTecnica {
  id?: string;
  programa: string;
  parceiros: string[];
  beneficiados: number;
  tipos_comunidade: string[];
}

export interface FormularioSecretariaMunicipalAgricultura {
  uuid: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  step_atual: number | null;
  institution_uuid: string | null;
  pacote_status: number | null;
  ano_referencia: number | null;
  nome_secretaria: string | null;
  endereco: string | null;
  endereco_numero: string | null;
  bairro: string | null;
  cep: string | null;
  email: string | null;
  telefone: string | null;
  telefone2: string | null;
  nome_responsavel: string | null;
  email_responsavel: string | null;
  tipo_unidade_administrativa: string | null;
  fundo_municipal_agricultura_familiar: boolean | null;
  tipo_publicacao: string | null;
  outro_servico_prestado: string | null;
  possui_outro_servico_prestado: boolean | null;
  nro_publicacao: string | null;
  data_publicacao: string | null;
  possui_escritorio_empaer: boolean | null;
  quantidade_escritorios: number | null;
  desenvolve_projetos_empaer: boolean | null;
  projeto_empaer_nome: string | null;
  servidores_cedidos_empaer: boolean | null;
  nome_servidores_cedidos_empaer: string[] | null;
  servidor_empaer_cedido_municipio: boolean | null;
  nome_servidor_empaer_cedido_municipio: string | null;
  possui_escritorio_indea: boolean | null;
  possui_unidade_sema: boolean | null;
  emissor_caf: boolean | null;
  possui_predio_proprio: boolean | null;
  quantidade_predio_proprio: number | null;
  possui_predio_alugado: boolean | null;
  quantidade_predio_alugado: number | null;
  possui_predio_cedido: boolean | null;
  quantidade_predio_cedido: number | null;
  possui_galpao: boolean | null;
  quantidade_galpao: number | null;
  possui_cozinha_piloto: boolean | null;
  quantidade_cozinha_piloto: number | null;
  servicos_prestados: string[];
  servicos_prestados_descritivo: ServicosPrestadosDescritivo[] | null;
  possui_salas: boolean | null;
  quantidade_salas: number | null;
  possui_auditorio: boolean | null;
  quantidade_auditorio: number | null;
  possui_computador: boolean | null;
  quantidade_computador: number | null;
  possui_notebook: boolean | null;
  quantidade_notebook: number | null;
  possui_tablet: boolean | null;
  quantidade_tablet: number | null;
  possui_impressora: boolean | null;
  quantidade_impressora: number | null;
  possui_receptor_gps_navegacao: boolean | null;
  quantidade_receptor_gps_navegacao: number | null;
  possui_receptor_gps_geodesico: boolean | null;
  quantidade_receptor_gps_geodesico: number | null;
  possui_equipamento_coleta_solo: boolean | null;
  quantidade_equipamento_coleta_solo: number | null;
  possui_drone: boolean | null;
  quantidade_drone: number | null;
  possui_veiculo_popular: boolean | null;
  quantidade_veiculo_popular: number | null;
  possui_veiculo_caminhonete: boolean | null;
  quantidade_veiculo_caminhonete: number | null;
  possui_veiculo_suv: boolean | null;
  quantidade_veiculo_suv: number | null;
  possui_caminhonete_tracada: boolean | null;
  quantidade_caminhonete_tracada: number | null;
  possui_veiculo_motocicleta: boolean | null;
  quantidade_veiculo_motocicleta: number | null;
  possui_caminhao_cacamba: boolean | null;
  quantidade_caminhao_cacamba: number | null;
  possui_caminhao_bau_sem_refrigeracao: boolean | null;
  quantidade_caminhao_bau_sem_refrigeracao: number | null;
  possui_caminhao_bau_refrigerado: boolean | null;
  quantidade_caminhao_bau_refrigerado: number | null;
  possui_caminhao_com_tanque_isotermico: boolean | null;
  quantidade_caminhao_com_tanque_isotermico: number | null;
  possui_caminhao_pipa: boolean | null;
  quantidade_caminhao_pipa: number | null;
  possui_caminhao_prancha: boolean | null;
  quantidade_caminhao_prancha: number | null;
  possui_caminhao_carga_seca: boolean | null;
  quantidade_caminhao_carga_seca: string | null;
  possui_trator_14cv: string | null;
  quantidade_trator_14cv: string | null;
  possui_trator_50cv: string | null;
  quantidade_trator_50cv: string | null;
  possui_trator_75cv: string | null;
  quantidade_trator_75cv: string | null;
  possui_trator_110cv: string | null;
  quantidade_trator_110cv: string | null;
  possui_implementos_agricolas_diversos: string | null;
  quantidade_implementos_agricolas_diversos: string | null;
  retroescavadeira: string | null;
  quantidade_retroescavadeira: string | null;
  escavadeira_hidraulica: string | null;
  quantidade_escavadeira_hidraulica: string | null;
  pa_carregadeira: string | null;
  quantidade_pa_carregadeira: string | null;
  possui_motoniveladora: string | null;
  quantidade_motoniveladora: string | null;
  possui_grade_aradora: string | null;
  quantidade_grade_aradora: string | null;
  possui_plantadeira: string | null;
  quantidade_plantadeira: string | null;
  possui_distribuidor_calcario: string | null;
  quantidade_distribuidor_calcario: string | null;
  viveiro_producao_mudas: string | null;
  quantidade_viveiro_producao_mudas: string | null;
  instrumento_legal_manutencao_agricola: boolean | null;
  tipo_publicacao_instrumento_legal_manutencao_agricola: string | null;
  numero_publicacao_instrumento_legal_manutencao_agricola: string | null;
  data_publicacao_instrumento_legal_manutencao_agricola: string | null;

  quadro_servidores_secretaria_quantidade: number | null;
  quadro_servidores_secretaria_lista: QuadroServidoresSecretaria[] | null;

  quantidade_familias_agricultura_familiar: number | null;
  quantidade_familias_agricultura_familiar_beneficiadas_total: number | null;

  quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas:
  | number
  | null;
  programas_assistencia_tecnica: ProgramaAssistenciaTecnica[] | null;
  ordem_importancia_assistencia_tecnica_outras_instituicoes: string[] | null;
  created_by: string | null;
  updated_by: string | null;
  deleted_by: string | null;
  pacote_formularios_uuid: string | null;
}

interface FormularioSecretariaMunicipalAgriculturaStore {
  formulario: FormularioSecretariaMunicipalAgricultura | null;
  listaServicosPrestados: { uuid: string; nome_servico: string }[];
  setListaServicosPrestados: (
    listaServicosPrestados: { uuid: string; nome_servico: string }[],
  ) => void;
  setFormulario: (
    formulario: FormularioSecretariaMunicipalAgricultura | null,
  ) => void;
  setPartialForm: (
    chave: keyof FormularioSecretariaMunicipalAgricultura,
    valor: any,
  ) => void;
  salvarRascunho: () => Promise<boolean>;
  enviarAprovacao: () => Promise<boolean>;
}

export const useFormularioSecretariaMunicipalAgriculturaStore =
  create<FormularioSecretariaMunicipalAgriculturaStore>((set, get) => ({
    formulario: null,
    listaServicosPrestados: [],
    setListaServicosPrestados: (
      listaServicosPrestados: { uuid: string; nome_servico: string }[],
    ) => set({ listaServicosPrestados }),
    setFormulario: (
      formulario: FormularioSecretariaMunicipalAgricultura | null,
    ) => set({ formulario }),
    setPartialForm: (
      chave: keyof FormularioSecretariaMunicipalAgricultura,
      valor: any,
    ) => {
      set((state) => ({
        formulario: { ...state.formulario!, [chave]: valor },
      }));
    },
    salvarRascunho: async () => {
      const formulario = get().formulario!;
      const response =
        await updateFormularioSecretariaMunicipalAgriculturaByUUID(
          get().formulario!.uuid,
          {
            ...get().formulario,
            pacote_status: formulario.pacote_status! < 2 ? 2 : formulario.pacote_status!,
          } as FormularioSecretariaMunicipalAgricultura,
        );
      if (response.Status == 'OK') {
        return true;
      }
      return false;
    },
    enviarAprovacao: async () => {
      const formulario = get().formulario!;

      if (formulario.pacote_status! < 3) {
        formulario.pacote_status = 3;
      }

      const response =
        await updateFormularioSecretariaMunicipalAgriculturaByUUID(
          get().formulario!.uuid,
          {
            ...get().formulario,
            pacote_status: formulario.pacote_status! < 3 ? 3 : formulario.pacote_status!,
          } as FormularioSecretariaMunicipalAgricultura,
        );

      if (response.Status == 'OK') {
        return true;
      }
      return false;
    },
  }));
